const PT = require("prop-types");
const React = require("react");
const createReactClass = require("create-react-class");
const CanvasMath = require("../canvasmath/CanvasMath");
const MeasuredEl = require("./MeasuredEl");
const CanvasView = require("./Canvas");
const Tooltip = require("./Tooltip");
const DrawingUtil = require("../util/DrawingUtil");
const Math2D = require("../util/Math2D");
const TrainerCore = require("../../../shared/TrainerCore");
const colors = require("../util/ColorUtil").getCurrentScheme();
const ContainerSize = require("../util/ContainerSize");
const CopyTable = require("../util/CopyTable");
const withContainerDims = require("../hoc/withContainerDims");
const SCU = require("../util/SCUUtil");
const {PLAYWRIGHT_TEST_IDS} = require("../../../shared/PlaywrightTestIds");

const styles = require("./styles/LevelProgressBar.css");

// Helper to apply higher-order components.
const augment = function(Component) {
	Component = withContainerDims(Component);
	return Component;
};
module.exports = augment(
	createReactClass({
		displayName: "levelProgressBar",

		propTypes: {
			xp: PT.number.isRequired,
			isExpandable: PT.bool,
			className: PT.string,

			// used by tutorial
			hideTooltip: PT.bool,

			// Injected by HOCs
			containerDims: PT.shape({
				width: PT.number.isRequired,
				height: PT.number.isRequired,
				left: PT.number.isRequired,
				top: PT.number.isRequired,
				windowWidth: PT.number.isRequired,
				windowHeight: PT.number.isRequired,
			}).isRequired,
		},

		shouldComponentUpdate: function(nextProps) {
			return !SCU.shallowEqOnKeys(this.props, nextProps, [
				"xp",
				"isExpandable",
				"className",
				"containerDims",
			]);
		},

		drawOctagon: function(context, x, y, diameter) {
			const sideLength = diameter / Math.sqrt(4 + 2 * Math.sqrt(2));
			context.moveTo(x + sideLength, y);
			for (let i = 1; i <= 8; i++) {
				context.lineTo(
					x + sideLength * Math.cos((i * 2 * Math.PI) / 8),
					y + sideLength * Math.sin((i * 2 * Math.PI) / 8)
				);
			}
		},

		drawOctagonBar: function(context, x, y, w, h) {
			context.beginPath();
			this.drawOctagon(context, x + h / 2, y + h / 2, h);
			context.moveTo(x + h / 2, y + h / 3);
			context.lineTo(x + w - h / 2, y + h / 3);
			context.lineTo(x + w - h / 2, y + (h * 2) / 3);
			context.lineTo(x + h / 2, y + (h * 2) / 3);
			context.lineTo(x + h / 2, y + h / 3);
			this.drawOctagon(context, x + w - h / 2, y + h / 2, h);
			context.closePath();
			context.fill();
		},

		getPositions: function(x, y, w, h) {
			return {
				x: x - w * 0.44,
				y: y + h / 12,
				w: w * 0.88,
				h: (h * 2) / 3,
			};
		},

		drawBaseBar: function(xpInfo, context, x, y, w, h) {
			const pos = this.getPositions(x, y, w, h);
			this.octagonCenters = {
				x1: pos.x + pos.h / 2,
				y1: pos.y + pos.h / 2,
				x2: pos.x + pos.w - pos.h / 2,
				y2: pos.y + pos.h / 2,
			};
			context.save();
			context.fillStyle = colors.levelShadow;
			this.drawOctagonBar(context, pos.x - 1, pos.y - 2, pos.w + 2, pos.h);
			context.fill();
			context.fillStyle = colors.levelHighlight;
			this.drawOctagonBar(context, pos.x + 1, pos.y + 2, pos.w, pos.h);
			context.fill();
			context.fillStyle = colors.levelMain;
			this.drawOctagonBar(context, pos.x, pos.y, pos.w, pos.h);
			context.fill();
			context.restore();
		},

		drawProgressBar: function(context, x, y, w, h, percent) {
			const pos = this.getPositions(x, y, w, h);
			context.beginPath();
			this.drawOctagon(context, pos.x + pos.h / 2, pos.y + pos.h / 2, pos.h);
			const startY = pos.y + pos.h / 3;
			const endY = pos.y + (pos.h * 2) / 3;
			const startX = pos.x + pos.h * 0.8;
			const barWidth = pos.w - (pos.h * 5) / 3;
			let endX1 = Math.max(startX, startX + barWidth * percent - pos.h / 12);
			let endX2 = Math.min(endX1 + pos.h / 6, startX + barWidth + pos.h / 24);
			if (percent === 1) {
				endX1 = startX + barWidth + pos.h / 3;
				endX2 = endX1;
			}
			context.moveTo(startX, startY);
			context.lineTo(endX1, startY);
			context.lineTo(endX2, endY);
			context.lineTo(startX, endY);

			if (percent === 1) {
				this.drawOctagon(
					context,
					pos.x + pos.w - pos.h / 2,
					pos.y + pos.h / 2,
					pos.h
				);
			}
			context.closePath();
			context.fill();
		},

		drawProgress: function(xpInfo, context, x, y, w, h) {
			context.save();
			const percent = xpInfo.currLevelXP / xpInfo.totalLevelXP;
			context.fillStyle = colors.levelProgressMain;
			this.drawProgressBar(context, x, y, w, h, percent);
			context.restore();
		},

		drawLabels: function(xpInfo, context, x, y, w, h) {
			const levels = [xpInfo.currLevel, xpInfo.nextLevel];
			const fontSize = ContainerSize.getFontSizes(this.props.containerDims)
				.levelBar;
			context.save();
			context.shadowOffsetX = 2;
			context.shadowOffsetY = 2;
			context.shadowColor = "rgba(0,0,0,0.5)";
			context.fillStyle = "#FFFFFF";

			//drawing the Level labels
			let currX, currY;
			for (let i = 1; i <= 2; i++) {
				const text = levels[i - 1];
				currX = this.octagonCenters["x" + i];
				currY = this.octagonCenters["y" + i];

				CanvasMath.drawInRect(context, {
					batex: text,
					rect: Math2D.makeRectInt([
						currX - h / 5.5,
						currY - h / 5.5,
						h / 3,
						h / 3,
					]),
					fontInfo: {size: fontSize, family: ["Roboto Slab"]},
					scaleDownOnly: true,
				});
			}

			//drawing the xp label
			CanvasMath.drawInRect(context, {
				batex: xpInfo.currLevelXP + " XP",
				rect: Math2D.makeRectInt([x - h, y + h / 3.8, h * 2, h / 3.5]),
				fontInfo: {size: fontSize * 0.8, family: ["Roboto Slab"]},
				scaleDownOnly: true,
			});

			context.restore();
		},

		drawLevelProgressBar: function(xpInfo, context, rect) {
			const {x, y, w, h} = rect;
			const centerX = x + w / 2;

			// Background
			DrawingUtil.drawTopBarYellow(
				context,
				x,
				y,
				w,
				h,
				this.props.isExpandable
			);
			// Base Bar
			this.drawBaseBar(xpInfo, context, centerX, y, w, h);
			//Progress
			this.drawProgress(xpInfo, context, centerX, y, w, h);
			// Labels
			this.drawLabels(xpInfo, context, centerX, y, w, h);

			return {
				w: w,
				h: h,
			};
		},

		render: function() {
			const isExpandable = this.props.isExpandable;
			const xpInfo = TrainerCore.getLevelXP(this.props.xp);
			const drawLevelProgressBar = context => {
				context.clearRect(0, 0, context.getWidth(), context.getHeight());
				this.drawLevelProgressBar(xpInfo, context, {
					x: 0,
					y: 0,
					w: Math.floor(context.getWidth()),
					// if is expandable, adjust height to not include the wart (pull tab)
					h: Math.floor(context.getHeight() / (isExpandable ? 1.5 : 1)),
				});
			};

			let mainClass = isExpandable ? styles.withWart : styles.main;
			if (this.props.className) {
				mainClass = this.props.className;
			}
			const progress = (
				<MeasuredEl
					className={mainClass}
					dataTestId={PLAYWRIGHT_TEST_IDS.LEVEL_PROGRESS_BAR}
				>
					<CanvasView draw={drawLevelProgressBar} />
				</MeasuredEl>
			);

			const progressBar = (
				<Tooltip
					tooltipText={
						this.props.hideTooltip
							? ""
							: CopyTable.forLevelProgressBar(
									xpInfo.totalLevelXP - xpInfo.currLevelXP,
									xpInfo.currLevel,
									xpInfo.nextLevel
							  )
					}
					className={styles.tooltip}
					size={"large"}
				>
					{progress}
				</Tooltip>
			);

			return progressBar;
		},
	})
);
